import { Button } from 'components/Button';
import Loader from "../generics/Loader";
import styled from 'styled-components';

export const IconContent = styled.div`
  gap: 5px;
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
`;

export const PreOrderButton = styled(Button)`
  img {
    max-width: none;
  }
`

export const Loading = styled(Loader)`
  padding: 0 9px;
`